import ProjectingForm from '../projectingItem/components/form/Form.vue';

export default {
  name: 'Projecting',

  components: {
    ProjectingForm,
  },

  data() {
    return {
      dialog: false,
      page: 1,
      totalVisible: 7,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    items() {
      const start = (this.page - 1) * this.totalVisible;
      const end = this.page * this.totalVisible;
      // eslint-disable-next-line
      return this.$store.state.design.projectings.slice(start, end);
    },
    count() {
      // eslint-disable-next-line
      return this.$store.state.design.projectings ? Math.ceil(this.$store.state.design.projectings.length / this.totalVisible) : 0;
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    messageClass(status) {
      return status ? '_new' : '';
    },
    statusClass(status) {
      switch (status) {
        case 'refusal':
        case 'rejected':
          return '_red';
        case 'under_review':
        case 'under_revision':
        case 'awaiting_payment':
        case 'document_preparation':
          return '_orange';
        case 'estimate_ready':
        case 'paid':
        case 'payment_confirmed':
        case 'equipment_purchased':
          return '_blue';
        case 'points_awarded':
        case 'estimate_confirmed':
        case 'project_ready':
          return '_green';
        default:
          return '_grey';
      }
    },
    goToItem(id) {
      this.$router.push(`/design/projecting-item/${id}/0/`);
    },
    goToAccountItem(id) {
      this.$router.push(`/design/projecting-item/${id}/1/`);
    },
    goChatItem(id) {
      this.$router.push(`/design/projecting-item/${id}/2/`);
    },
  },
  mounted() {
    this.$store.dispatch('design/ProjectingGetList', {
      profile_id: this.user.profile_id,
    });
    this.$store.dispatch('SetTitle', 'Проектирование');
  },
};
